import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import EditMemberListing from '@/modules/manage-member/components/EditMember/components/EditMemberListing'

function EditMemberPage() {
	return (
		<PageContainer>
			<EditMemberListing />
		</PageContainer>
	)
}

const GuardedEditMemberPage = withUserPermission(EditMemberPage, {
	permissionType: PermissionType.Write,
	permissionKey: [PermissionKeys.MANAGE_OPERATOR],
})

export default GuardedEditMemberPage
